<template>
    <div style="position: relative">
        <v-img :style="imageStyle" v-bind="$attrs" v-on="$listeners">
            <template v-for="(_, slot) of $scopedSlots" #[slot]="scope">
                <slot :name="slot" v-bind="scope"></slot>
            </template>
        </v-img>
        <b-confirm
            v-if="deletable"
            text="Are you sure you want to remove the image?"
            title="Are you sure?"
            @true="triggerDelete"
        >
            <template #button="{ on, dialog }">
                <v-btn class="delete-btn" icon small @click="dialog = true" v-on="on">
                    <v-icon small>fas fa-trash</v-icon>
                </v-btn>
            </template>
        </b-confirm>
    </div>
</template>

<script>
export default {
    props: {
        deletable: {
            type: Boolean,
            required: false,
            default: false,
        },
        bordered: {
            type: Boolean,
            required: false,
            default: false,
        },
    },
    computed: {
        imageStyle() {
            return this.bordered ? 'border: 1px solid #9e9e9e;' : '';
        },
    },
    methods: {
        triggerDelete() {
            this.$emit('delete');
        },
    },
};
</script>

<style scoped>
.delete-btn {
    position: absolute;
    top: 2px;
    right: 0px;
}
</style>
